
import request from "@/utils/request";




// export const transaction = async (code, data) => {
//   const res = await request({
//     method: "POST",
//     url: `/${code}/transaction`,
//     data
//   });
//   return res;
// }

export const getSpotList = async (chainCode, model) => {

  const { data } = await request({
    url: `/perp/v1/public/assets?platform=${model}&chainCode=${chainCode}`,
  });
  if (data && data.length) {
    let list = data.map(item => {
      if (item.asset) {
        item.symbol = item.asset
        item.icon = item.logoLink
      }
      return item
    })
    return list
  } else {
    return []
  }
};


export const getMarkets = async (model) => {
  const { data } = await request({
    url: `/perp/v1/public/perpetuals?platform=${model}`
  })
  if (data && data.length) {
    let list = data.map(item => {
      item.leverage = item.maxLeverage
      item.icon = item.logoLink
      item.minSize = item.minTrade
      if (model == 'Hyperliquid') {
        item.minSizeType = 'u'
      } else {
        item.minSizeType = 's'
      }
      return item
    })
    return list
  } else {
    return []
  }
};


export const getKline = async (p) => {
  let interval = p.interval
  if (interval == '30') interval = 15
  if (interval == '1D' || interval == '1W' || interval == '1M') interval = 'D'

  let countBack = parseInt((p.to / 60 - p.from / 60) / (interval == 'D' ? 60 * 24 : Number(interval)))
  let url = `/drift/v1/public/kline?marketIndex=${p.marketIndex}&marketType=perp&resolution=${interval}&from=${p.from * 1000}&to=${p.to * 1000}&countBack=${countBack}`
  const { data } = await request({
    url
  })
  if (data && data.candles) {

    let list = data.candles.map(item => {
      return {
        time: Number(item.start),

        close: Number(item.fillClose),
        high: Number(item.fillHigh),
        low: Number(item.fillLow),
        open: Number(item.fillOpen),

        volume: Number(item.quoteVolume),
      }
    })
    if (p.interval == '30') {
      let newList = []
      let obj = {}
      list.forEach((item, i) => {
        if (i % 2 == 0) {
          obj = item
        } else {
          obj.close = item.close
          obj.high = item.high > obj.high ? item.high : obj.high
          obj.low = item.low < obj.low ? item.low : obj.low
          obj.volume = (Number(obj.volume) + Number(item.volume)) + ''
          newList.push(obj)
        }
      })
      list = newList
    }
    if (p.interval == '1W') {
      let newList = []
      let obj = {}
      list.forEach((item, i) => {
        if (i % 7 == 0) {
          obj = {
            ...item,
            open: obj.close || 0
          }
        } else {
          obj.close = item.close
          obj.high = item.high > obj.high ? item.high : obj.high
          obj.low = item.low < obj.low ? item.low : obj.low
          obj.volume = (Number(obj.volume) + Number(item.volume)) + ''
          if (i == list.length - 1 || i % 7 == 6) {
            newList.push(obj)
          }
        }
      })
      list = newList
    }
    if (p.interval == '1M') {
      let newList = []
      let obj = {}
      list.forEach((item, i) => {
        if (i % 30 == 0) {
          obj = {
            ...item,
            open: obj.close || 0
          }
        } else {
          obj.close = item.close
          obj.high = item.high > obj.high ? item.high : obj.high
          obj.low = item.low < obj.low ? item.low : obj.low
          obj.volume = parseInt(Number(obj.volume) + Number(item.volume)) + ''
          if (i == list.length - 1 || i % 30 == 29) {
            newList.push(obj)
          }
        }
      })
      list = newList
    }
    return list
  } else {
    return []
  }
};
